import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        delay: { type: Number, default: 1000 }
    }

    connect() {
        this.timeout = null
    }

    save() {
        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
            this.element.requestSubmit()
        }, this.delayValue)
    }
}
